module.exports = {
  expirationTime: 60 * 60 * 1000, // 1h
  url: 'security/refresh-token'
}
